import React from 'react';
export function SolutionSection() {
  const benefits = ['Cultivar tus propios alimentos', 'Comer más natural y fresco', 'Tener control sobre lo que consumes', 'Crear un espacio vivo en tu casa', 'Disfrutar el proceso'];
  return <section className="relative bg-garden-dark py-10 px-4 sm:px-6 lg:px-8 text-white text-center overflow-hidden" data-id="element-158">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-159">
        <div className="absolute top-1/4 -left-32 w-96 h-96 bg-garden-medium rounded-full opacity-20 blur-[100px]" data-id="element-160"></div>
        <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-garden-light rounded-full opacity-20 blur-[100px]" data-id="element-161"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-162">
        <div className="inline-block bg-white/10 backdrop-blur-md border border-white/20 text-white font-bold px-6 py-1.5 rounded-full mb-4 text-sm tracking-widest uppercase shadow-lg" data-id="element-163">
          ✅ LA SOLUCIÓN
        </div>

        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black uppercase tracking-tight mb-4 drop-shadow-lg" data-id="element-164">
          EL MANUAL DEL JARDINERO
        </h2>

        <p className="text-base sm:text-lg text-white/90 mb-4 leading-relaxed max-w-3xl mx-auto font-medium" data-id="element-165">
          Una guía práctica y paso a paso para que puedas crear tu huerta en
          casa y empezar a cultivar tus propios alimentos.
        </p>

        <p className="text-sm sm:text-base text-white/70 mb-8 max-w-2xl mx-auto" data-id="element-166">
          Aunque empieces desde cero. Aunque vivas en un departamento.
        </p>

        <div className="grid grid-cols-3 gap-3 sm:gap-5 mb-8 max-w-3xl mx-auto" data-id="element-167">
          <div className="glass p-5 sm:p-6 rounded-2xl transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:bg-white/15 group" data-id="element-168">
            <div className="text-4xl mb-2 transform group-hover:scale-110 transition-transform duration-300" data-id="element-169">
              📂
            </div>
            <p className="text-sm sm:text-base font-bold tracking-wide" data-id="element-170">
              Abrís el manual
            </p>
          </div>
          <div className="glass p-5 sm:p-6 rounded-2xl transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:bg-white/15 group" data-id="element-171">
            <div className="text-4xl mb-2 transform group-hover:scale-110 transition-transform duration-300" data-id="element-172">
              🌱
            </div>
            <p className="text-sm sm:text-base font-bold tracking-wide" data-id="element-173">
              Sabés qué plantar
            </p>
          </div>
          <div className="glass p-5 sm:p-6 rounded-2xl transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:bg-white/15 group" data-id="element-174">
            <div className="text-4xl mb-2 transform group-hover:scale-110 transition-transform duration-300" data-id="element-175">
              ✏️
            </div>
            <p className="text-sm sm:text-base font-bold tracking-wide" data-id="element-176">
              Lo aplicás paso a paso
            </p>
          </div>
        </div>

        <p className="font-serif text-xl sm:text-2xl font-bold text-earth-light italic mb-8" data-id="element-177">
          Sin adivinar. Sin complicarte.
        </p>

        {/* ¿Qué vas a lograr? */}
        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 sm:p-8 max-w-3xl mx-auto" data-id="element-178">
          <h3 className="font-serif text-2xl sm:text-3xl font-black mb-4" data-id="element-179">
            🥗 ¿Qué vas a lograr?
          </h3>
          <p className="text-white/80 mb-4 text-base" data-id="element-180">Vas a poder:</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-left max-w-2xl mx-auto" data-id="element-181">
            {benefits.map((b, i) => <div key={i} className="flex items-center text-white/90 font-semibold text-sm sm:text-base" data-id="element-182">
                <span className="text-garden-light mr-2 text-lg" data-id="element-183">✔</span>
                {b}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}